import {FormActionButton} from '@cm/ui-modules';

// ux-guidelines § Buttons — hierarchy / form page: Cancel is neutral (never red — red is only for
// destructive actions), Save is the one primary (`color: 'primary'` → filled).
export const DEFAULT_FORM_ACTION_BUTTONS: FormActionButton[] = [
  {
    action: 'cancel',
    label: 'common.cancel',
    side: 'left',
    visible: true,
    type: 'button',
  },
  {
    color: 'primary',
    action: 'save',
    side: 'right',
    icon: 'check',
    label: 'common.save',
    visible: true,
    type: 'submit',
  }
];
